import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutOneComponent } from './components/layout-one/layout-one.component';
import { BaseAuthService } from '@shared/utils/base-auth';
import { MenuItemsService } from '@shared/utils/menu-items';
import { MockBaseAuthService } from './services/mock-base-auth/mock-base-auth.service';
import { SharedUiNavbarsModule } from '@shared/ui/navbars';
import { SharedUiPageToolbarsModule } from '@shared/ui/page-toolbars';
import { SharedUiButtonsModule } from '@shared/ui/buttons';
import { SharedUiIconsModule } from '@shared/ui/icons';
import { SharedFeatureTranslateModule } from '@shared/feature/translate';
import { LoginComponent } from './components/login/login.component';
import { SharedFeatureFormsModule } from '@shared/feature/forms';
import { LayoutWrapperComponent } from './components/layout-wrapper/layout-wrapper.component';
import { RouterModule } from '@angular/router';
import { LayoutConfirmComponent } from './components/layout-confirm/layout-confirm.component';
import { SharedUiCardsModule } from '@shared/ui/cards';
import { SharedFeatureNotificationHandlingModule } from '@shared/feature/notification-handling';
import { MockMenuItemsService } from './services/mock-menu-items/mock-menu-items.service';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { GoogleAnalyticsTrackingComponent } from './components/google-analytics-tracking/google-analytics-tracking.component';
import { MicrosoftClarityTrackingComponent } from './components/microsoft-clarity-tracking/microsoft-clarity-tracking.component';
import { PageForbiddenComponent } from './components/page-forbidden/page-forbidden.component';
import { RegisterGuestComponent } from './components/register-guest/register-guest.component';
import { VerifyPhoneNumberComponent } from './components/verify-phone-number/verify-phone-number.component';
import { SharedUiModalModule } from '@shared/ui/modal';
import { PageInternalServerErrorComponent } from './components/page-internal-server-error/page-internal-server-error.component';
import { SharedFeatureLoadingModule } from '@shared/feature/loading';
import { B2cAccessForbiddenComponent } from './components/b2c-access-forbidden/b2c-access-forbidden.component';
import { B2cUserNotFoundComponent } from './components/b2c-user-not-found/b2c-user-not-found.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationBannerComponent } from './components/notification-banner/notification-banner.component';
import { LayoutTwoComponent } from './components/layout-two/layout-two.component';
import { GoogleMapsComponent } from './components/google-maps/google-maps.component';
import { SharedUtilsListOfficerModule } from '@shared/utils/list-officer';
import { MenubarModule } from 'primeng/menubar';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedUiNavbarsModule,
    SharedUiPageToolbarsModule,
    SharedUiButtonsModule,
    SharedUiIconsModule,
    SharedFeatureTranslateModule,
    SharedFeatureFormsModule,
    SharedFeatureNotificationHandlingModule,
    SharedUiCardsModule,
    SharedUiModalModule,
    SharedFeatureLoadingModule,
    NgbTooltipModule,
    SharedUtilsListOfficerModule,
    MenubarModule,
  ],
  declarations: [
    LayoutOneComponent,
    LoginComponent,
    LayoutWrapperComponent,
    LayoutConfirmComponent,
    PageNotFoundComponent,
    GoogleAnalyticsTrackingComponent,
    MicrosoftClarityTrackingComponent,
    PageForbiddenComponent,
    RegisterGuestComponent,
    VerifyPhoneNumberComponent,
    B2cAccessForbiddenComponent,
    B2cUserNotFoundComponent,
    PageInternalServerErrorComponent,
    NotificationBannerComponent,
    LayoutTwoComponent,
    GoogleMapsComponent,
  ],
  exports: [LayoutOneComponent, LoginComponent, LayoutConfirmComponent, PageNotFoundComponent],
  providers: [
    { provide: BaseAuthService, useClass: MockBaseAuthService },
    { provide: MenuItemsService, useClass: MockMenuItemsService },
  ],
})
export class SharedFeaturePageLayoutModule {}
